// Action Types
import { 
  ACCOUNT_SETTINGS_SIDERBAR,
  ACCOUNT_SETTINGS_SAVE,
  ACCOUNT_SETTINGS_SAVE_RESPONSE,
  GET_PREFERENCE,
  GET_PREFERENCE_RESULT,
  CLEAR_REDUX
} from "Redux/actionTypes";

/**
 * Initial State Contacts
 */
const INITIAL_STATE = {
  loading: false,
  showSliderAccountSettings: false,
  error: false,
  updatedAccount: false,
  preferences: {}
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACCOUNT_SETTINGS_SAVE:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case ACCOUNT_SETTINGS_SAVE_RESPONSE: 
      return {
        ...state,
        showSliderAccountSettings: false,
        updatedAccount: action.payload?.updatedAccount,
        error: action.payload?.error,
        loading: false,
      };  
    case ACCOUNT_SETTINGS_SIDERBAR:
      return {
        ...state,
        error: false,
        showSliderAccountSettings: action.payload,
        loading: false,
        updatedAccount: false
      };
      loading
    case GET_PREFERENCE:
      return {
        ...state,
        loading: true
      };
    case GET_PREFERENCE_RESULT:
      if(action.payload?.preference) {
        return {
          ...state,
          loading: false,
          preferences: {
            ...state.preferences,
            [action.payload?.preference]: action.payload?.preferenceValue
          }
        };
      }
      return {
        ...state,
        loading: false
      };
    case CLEAR_REDUX:
      return ["", "ACCOUNT_SETTINGS"].includes(action.payload.option)
        ? action.payload.parameters
          ? { ...state, ...action.payload.parameters }
          : { ...INITIAL_STATE }
        : { ...state };  
    default:
      return state;
  }
};
